module.exports = __webpack_public_path__ + "img/security2.07d67f96.svg";